<template>
  <div class="date-compare-container">
    <Checkbox class="date-compare-checkbox" v-model="compare">
      对比日期
    </Checkbox>
    <div class="date-compare-select" v-show="compare" :style="{left: showTime ? '160px' : '90px'}">
      <Select v-model="rangeType"
              size="small"
              ref="rangeTypeSelect"
              :placeholder="custom"
              :clearable="true"
              @on-change="handleSelectCompare">
        <Option value="previous">上一时段</Option>
        <Option value="sameTermOfLastYear">去年同期</Option>
      </Select>
      <Input type="text" size="small" disabled v-model="comparedDate.from"/>
      <span>-</span>
      <Input type="text" size="small" disabled v-model="comparedDate.to"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "date-compare",
    props: {
      comparedRange: {
        type: Object,
        default: () => ({})
      },
      isCompared: {
        type: Boolean,
        default: false
      },
      term: {
        type: String,
        default: ''
      },
      showTime: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        compare: !!this.comparedRange.from,
        custom: '自定义',
        rangeType: this.term || '',
        comparedDate: {
          from: this.comparedRange.from || '',
          to: this.comparedRange.to || ''
        }
      }
    },
    methods: {
      handleSelectCompare(value) {
        this.$emit('on-range-type-change', value);
      },
      clearRangeType() {
        this.$refs.rangeTypeSelect.clearSingleSelect();
      },
    },
    watch: {
      term(term) {
        this.rangeType = term;
      },
      isCompared(bool) {
        this.compare = bool;
      },
      compare(compare) {
        this.rangeType = '';
        this.$emit('on-compare', compare);
      },
      comparedRange({from, to}) {
        this.comparedDate = {
          from: from ? from.Format('start') : '',
          to: to ? to.Format() : ''
        }
      },
    }
  }
</script>

<style scoped>
  .date-compare-container {
    position: relative;
  }

  .date-compare-checkbox {
    float: left;
    padding: 3px 7px 2px;
  }

  .date-compare-select {
    position: absolute;
    text-align: left;
  }

  .date-compare-select > div {
    width: 120px;
    float: left;
    margin-right: 5px;
  }

  .date-compare-select > div:first-child {
    width: 90px;
  }

  .date-compare-select > span {
    width: 10px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/base/date-compare.vue